import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle } from 'lucide-react';
import MemberLayout from '../../components/MemberLayout';
import { PageLoader } from '../../components/ui';
import api, { errMsg } from '../../services/api';

// One-click "my details are still correct" from the yearly reminder email
export default function ConfirmDetails() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: 'loading' });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post('/public/confirm-details', { token: params.get('token') })
      .then(r => setState({ status: 'ok', name: r.data.fullName }))
      .catch(err => setState({ status: 'error', message: errMsg(err) }));
  }, [params]);

  return (
    <MemberLayout narrow>
      <div className="card p-7 text-center">
        {state.status === 'loading' && <PageLoader />}
        {state.status === 'ok' && (
          <>
            <CheckCircle2 size={52} className="mx-auto text-green-600" />
            <h1 className="mt-3 font-display text-3xl font-bold text-navy-900">Thank you{state.name ? `, ${state.name.split(' ')[0]}` : ''}!</h1>
            <p className="mt-2 text-sm text-gray-600">Your details are confirmed for another year.</p>
            <Link to="/profile" className="btn-outline mt-6">View my profile</Link>
          </>
        )}
        {state.status === 'error' && (
          <>
            <XCircle size={48} className="mx-auto text-red-500" />
            <p className="mt-3 text-sm text-gray-600">{state.message}</p>
            <Link to="/login" className="btn-primary mt-6">Log in to confirm your details</Link>
          </>
        )}
      </div>
    </MemberLayout>
  );
}
